var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOthermaritalselected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 107,
    viewBox: "0 0 109 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_378_2496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 99,
    height: 97,
    rx: 8,
    fill: "url(#paint0_linear_378_2496)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8789 33L43.3297 34.8548L44.8284 33.3561L42.8789 33ZM42.4655 33.125L42.9191 34.9856L41.0586 34.5347L42.4655 33.125ZM51.1078 34.5017C50.3345 34.8746 49.6197 35.3581 48.986 35.9373L48.9859 35.9373C47.8401 35.842 46.6897 36.0531 45.6525 36.5488L45.5664 34.5676C47.3526 33.9175 49.3067 33.8943 51.1078 34.5017ZM42.0297 43.5296C42.2592 44.8462 42.8896 46.0596 43.8347 47.0046L43.8348 47.0048C45.1904 48.3701 47.0834 49.0615 48.9999 48.8912C49.633 49.4712 50.3479 49.9549 51.1218 50.3268C49.1227 51.0077 46.9401 50.9068 45.0124 50.0442C43.0845 49.1816 41.555 47.621 40.7308 45.6765C39.9069 43.7318 39.8494 41.5477 40.5702 39.5625L42.5514 39.6486C41.9822 40.8577 41.7999 42.2131 42.0297 43.5296ZM40.9609 34.9531L41.406 36.7792L42.7898 35.3981L40.9609 34.9531ZM40.9934 36.9113L39.1328 36.4575L40.5398 35.0508L40.9934 36.9113ZM40.8634 37.321L39 36.8672L39.3589 38.8255L40.8634 37.321ZM41.3251 37.4727L44.6585 39.3102L39.6973 39.0977L41.3251 37.4727ZM45.0143 39.0141L43.1537 35.6406L41.6406 37.1537L45.0143 39.0141ZM43.4727 35.3243L45.0977 33.6992L45.3102 38.6577L43.4727 35.3243Z",
    fill: "url(#paint1_linear_378_2496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30H54.8046V32.1686H54V30Z",
    fill: "url(#paint2_linear_378_2496)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 32.8591H54.8046V35.0277H54V32.8591Z",
    fill: "url(#paint3_linear_378_2496)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54 35.7114H54.8046V37.8801H54V35.7114Z",
    fill: "url(#paint4_linear_378_2496)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38.5635H54.8046V40.7321H54V38.5635Z",
    fill: "url(#paint5_linear_378_2496)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54 41.4158H54.8046V43.5844H54V41.4158Z",
    fill: "url(#paint6_linear_378_2496)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54 44.2678H54.8046V46.4365H54V44.2678Z",
    fill: "url(#paint7_linear_378_2496)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47.1267H54.8046V49.2953H54V47.1267Z",
    fill: "url(#paint8_linear_378_2496)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M54 49.979H54.8046V52.1476H54V49.979Z",
    fill: "url(#paint9_linear_378_2496)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52.8311H54.8046V54.9997H54V52.8311Z",
    fill: "url(#paint10_linear_378_2496)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1216 33L65.6708 34.8548L64.1724 33.3561L66.1216 33ZM66.5349 33.125L66.0813 34.9856L67.9416 34.5347L66.5349 33.125ZM57.8942 34.5017C58.6673 34.8746 59.382 35.3581 60.0156 35.9373L60.0157 35.9373C61.1613 35.842 62.3115 36.0531 63.3486 36.5488L63.4347 34.5676C61.6488 33.9175 59.695 33.8943 57.8942 34.5017ZM66.9708 43.5296C66.7413 44.8462 66.111 46.0596 65.166 47.0046L65.1659 47.0048C63.8105 48.3701 61.9178 49.0615 60.0016 48.8912C59.3686 49.4712 58.6538 49.9549 57.88 50.3268C59.8789 51.0077 62.0611 50.9068 63.9885 50.0442C65.9161 49.1816 67.4454 47.621 68.2694 45.6765C69.0933 43.7318 69.1507 41.5477 68.43 39.5625L66.4492 39.6486C67.0183 40.8577 67.2005 42.2131 66.9708 43.5296ZM68.0392 34.9531L67.5943 36.7792L66.2106 35.3981L68.0392 34.9531ZM68.0069 36.9113L69.8672 36.4575L68.4605 35.0508L68.0069 36.9113ZM68.1369 37.321L70 36.8672L69.6412 38.8255L68.1369 37.321ZM67.6751 37.4727L64.3422 39.3102L69.3027 39.0977L67.6751 37.4727ZM63.9865 39.0141L65.8468 35.6406L67.3597 37.1537L63.9865 39.0141ZM65.528 35.3243L63.9032 33.6992L63.6907 38.6577L65.528 35.3243Z",
    fill: "url(#paint11_linear_378_2496)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.732 83.14C35.9387 83.14 35.2573 83.0047 34.688 82.734C34.1187 82.454 33.68 82.0293 33.372 81.46C33.064 80.8813 32.8913 80.158 32.854 79.29C32.8447 78.8793 32.84 78.4873 32.84 78.114C32.84 77.7313 32.8447 77.3347 32.854 76.924C32.8913 76.0653 33.0687 75.3513 33.386 74.782C33.7127 74.2033 34.1607 73.774 34.73 73.494C35.3087 73.2047 35.976 73.06 36.732 73.06C37.4973 73.06 38.1647 73.2047 38.734 73.494C39.3127 73.774 39.7653 74.2033 40.092 74.782C40.4187 75.3513 40.596 76.0653 40.624 76.924C40.6427 77.3347 40.652 77.7313 40.652 78.114C40.652 78.4873 40.6427 78.8793 40.624 79.29C40.596 80.158 40.4233 80.8813 40.106 81.46C39.798 82.0293 39.3593 82.454 38.79 82.734C38.2207 83.0047 37.5347 83.14 36.732 83.14ZM36.732 81.95C37.4507 81.95 38.034 81.7353 38.482 81.306C38.9393 80.8767 39.1867 80.1813 39.224 79.22C39.2427 78.8 39.252 78.4267 39.252 78.1C39.252 77.764 39.2427 77.3907 39.224 76.98C39.2053 76.336 39.084 75.8133 38.86 75.412C38.6453 75.0107 38.356 74.7167 37.992 74.53C37.628 74.3433 37.208 74.25 36.732 74.25C36.2747 74.25 35.864 74.3433 35.5 74.53C35.136 74.7167 34.842 75.0107 34.618 75.412C34.4033 75.8133 34.282 76.336 34.254 76.98C34.2447 77.3907 34.24 77.764 34.24 78.1C34.24 78.4267 34.2447 78.8 34.254 79.22C34.2913 80.1813 34.5387 80.8767 34.996 81.306C35.4533 81.7353 36.032 81.95 36.732 81.95ZM45.3526 83C44.8299 83 44.4053 82.902 44.0786 82.706C43.7519 82.5007 43.5139 82.216 43.3646 81.852C43.2153 81.4787 43.1406 81.04 43.1406 80.536V76.84H42.0486C41.9553 76.84 41.8759 76.812 41.8106 76.756C41.7546 76.6907 41.7266 76.6113 41.7266 76.518V76.042C41.7266 75.9487 41.7546 75.874 41.8106 75.818C41.8759 75.7527 41.9553 75.72 42.0486 75.72H43.1406V73.382C43.1406 73.2887 43.1686 73.214 43.2246 73.158C43.2899 73.0927 43.3693 73.06 43.4626 73.06H44.1206C44.2139 73.06 44.2886 73.0927 44.3446 73.158C44.4099 73.214 44.4426 73.2887 44.4426 73.382V75.72H46.1786C46.2719 75.72 46.3466 75.7527 46.4026 75.818C46.4679 75.874 46.5006 75.9487 46.5006 76.042V76.518C46.5006 76.6113 46.4679 76.6907 46.4026 76.756C46.3466 76.812 46.2719 76.84 46.1786 76.84H44.4426V80.438C44.4426 80.8767 44.5173 81.222 44.6666 81.474C44.8159 81.726 45.0819 81.852 45.4646 81.852H46.3186C46.4119 81.852 46.4866 81.8847 46.5426 81.95C46.6079 82.006 46.6406 82.0807 46.6406 82.174V82.678C46.6406 82.7713 46.6079 82.8507 46.5426 82.916C46.4866 82.972 46.4119 83 46.3186 83H45.3526ZM48.3154 83C48.222 83 48.1427 82.972 48.0774 82.916C48.0214 82.8507 47.9934 82.7713 47.9934 82.678V73.382C47.9934 73.2887 48.0214 73.214 48.0774 73.158C48.1427 73.0927 48.222 73.06 48.3154 73.06H49.0154C49.118 73.06 49.1974 73.0927 49.2534 73.158C49.3094 73.214 49.3374 73.2887 49.3374 73.382V76.644C49.5894 76.3267 49.8974 76.07 50.2614 75.874C50.6254 75.678 51.0874 75.58 51.6474 75.58C52.254 75.58 52.7674 75.7153 53.1874 75.986C53.6167 76.2473 53.9387 76.616 54.1534 77.092C54.3774 77.5587 54.4894 78.1047 54.4894 78.73V82.678C54.4894 82.7713 54.4614 82.8507 54.4054 82.916C54.3494 82.972 54.27 83 54.1674 83H53.4674C53.374 83 53.2947 82.972 53.2294 82.916C53.1734 82.8507 53.1454 82.7713 53.1454 82.678V78.8C53.1454 78.1467 52.9867 77.638 52.6694 77.274C52.352 76.9007 51.8854 76.714 51.2694 76.714C50.6907 76.714 50.224 76.9007 49.8694 77.274C49.5147 77.638 49.3374 78.1467 49.3374 78.8V82.678C49.3374 82.7713 49.3094 82.8507 49.2534 82.916C49.1974 82.972 49.118 83 49.0154 83H48.3154ZM59.4086 83.14C58.4473 83.14 57.6819 82.846 57.1126 82.258C56.5433 81.6607 56.2306 80.8487 56.1746 79.822C56.1653 79.7007 56.1606 79.5467 56.1606 79.36C56.1606 79.164 56.1653 79.0053 56.1746 78.884C56.2119 78.2213 56.3659 77.6427 56.6366 77.148C56.9073 76.644 57.2759 76.2567 57.7426 75.986C58.2186 75.7153 58.7739 75.58 59.4086 75.58C60.1179 75.58 60.7106 75.7293 61.1866 76.028C61.6719 76.3267 62.0406 76.7513 62.2926 77.302C62.5446 77.8527 62.6706 78.4967 62.6706 79.234V79.472C62.6706 79.5747 62.6379 79.654 62.5726 79.71C62.5166 79.766 62.4419 79.794 62.3486 79.794H57.5046C57.5046 79.8033 57.5046 79.822 57.5046 79.85C57.5046 79.878 57.5046 79.9013 57.5046 79.92C57.5233 80.3027 57.6073 80.662 57.7566 80.998C57.9059 81.3247 58.1206 81.5907 58.4006 81.796C58.6806 82.0013 59.0166 82.104 59.4086 82.104C59.7446 82.104 60.0246 82.0527 60.2486 81.95C60.4726 81.8473 60.6546 81.7353 60.7946 81.614C60.9346 81.4833 61.0279 81.3853 61.0746 81.32C61.1586 81.1987 61.2239 81.1287 61.2706 81.11C61.3173 81.082 61.3919 81.068 61.4946 81.068H62.1666C62.2599 81.068 62.3346 81.096 62.3906 81.152C62.4559 81.1987 62.4839 81.2687 62.4746 81.362C62.4653 81.502 62.3906 81.6747 62.2506 81.88C62.1106 82.076 61.9099 82.272 61.6486 82.468C61.3873 82.664 61.0699 82.8273 60.6966 82.958C60.3233 83.0793 59.8939 83.14 59.4086 83.14ZM57.5046 78.828H61.3406V78.786C61.3406 78.366 61.2613 77.9927 61.1026 77.666C60.9533 77.3393 60.7339 77.0827 60.4446 76.896C60.1553 76.7 59.8099 76.602 59.4086 76.602C59.0073 76.602 58.6619 76.7 58.3726 76.896C58.0926 77.0827 57.8779 77.3393 57.7286 77.666C57.5793 77.9927 57.5046 78.366 57.5046 78.786V78.828ZM64.6666 83C64.5733 83 64.4939 82.972 64.4286 82.916C64.3726 82.8507 64.3446 82.7713 64.3446 82.678V76.056C64.3446 75.9627 64.3726 75.8833 64.4286 75.818C64.4939 75.7527 64.5733 75.72 64.6666 75.72H65.3106C65.4039 75.72 65.4833 75.7527 65.5486 75.818C65.6139 75.8833 65.6466 75.9627 65.6466 76.056V76.672C65.8333 76.3547 66.0899 76.1167 66.4166 75.958C66.7433 75.7993 67.1353 75.72 67.5926 75.72H68.1526C68.2459 75.72 68.3206 75.7527 68.3766 75.818C68.4326 75.874 68.4606 75.9487 68.4606 76.042V76.616C68.4606 76.7093 68.4326 76.784 68.3766 76.84C68.3206 76.896 68.2459 76.924 68.1526 76.924H67.3126C66.8086 76.924 66.4119 77.0733 66.1226 77.372C65.8333 77.6613 65.6886 78.058 65.6886 78.562V82.678C65.6886 82.7713 65.6559 82.8507 65.5906 82.916C65.5253 82.972 65.4459 83 65.3526 83H64.6666ZM72.183 83.14C71.6603 83.14 71.2123 83.0747 70.839 82.944C70.4656 82.8133 70.1623 82.6547 69.929 82.468C69.6956 82.2813 69.5183 82.0947 69.397 81.908C69.285 81.7213 69.2243 81.572 69.215 81.46C69.2056 81.3573 69.2383 81.278 69.313 81.222C69.3876 81.166 69.4623 81.138 69.537 81.138H70.153C70.209 81.138 70.251 81.1473 70.279 81.166C70.3163 81.1753 70.363 81.2127 70.419 81.278C70.5403 81.4087 70.6756 81.5393 70.825 81.67C70.9743 81.8007 71.1563 81.908 71.371 81.992C71.595 82.076 71.8703 82.118 72.197 82.118C72.673 82.118 73.065 82.0293 73.373 81.852C73.681 81.6653 73.835 81.3947 73.835 81.04C73.835 80.8067 73.7696 80.62 73.639 80.48C73.5176 80.34 73.2936 80.214 72.967 80.102C72.6496 79.99 72.211 79.8733 71.651 79.752C71.091 79.6213 70.6476 79.4627 70.321 79.276C69.9943 79.08 69.761 78.8513 69.621 78.59C69.481 78.3193 69.411 78.016 69.411 77.68C69.411 77.3347 69.5136 77.0033 69.719 76.686C69.9243 76.3593 70.223 76.0933 70.615 75.888C71.0163 75.6827 71.5156 75.58 72.113 75.58C72.5983 75.58 73.0136 75.6407 73.359 75.762C73.7043 75.8833 73.989 76.0373 74.213 76.224C74.437 76.4013 74.605 76.5787 74.717 76.756C74.829 76.9333 74.8896 77.0827 74.899 77.204C74.9083 77.2973 74.8803 77.3767 74.815 77.442C74.7496 77.498 74.675 77.526 74.591 77.526H74.003C73.9376 77.526 73.8816 77.512 73.835 77.484C73.7976 77.456 73.7603 77.4233 73.723 77.386C73.6296 77.2647 73.5176 77.1433 73.387 77.022C73.2656 76.9007 73.1023 76.8027 72.897 76.728C72.701 76.644 72.4396 76.602 72.113 76.602C71.6463 76.602 71.2963 76.7 71.063 76.896C70.8296 77.092 70.713 77.3393 70.713 77.638C70.713 77.8153 70.7643 77.974 70.867 78.114C70.9696 78.254 71.1656 78.38 71.455 78.492C71.7443 78.604 72.1736 78.7253 72.743 78.856C73.359 78.9773 73.8443 79.1407 74.199 79.346C74.5536 79.5513 74.8056 79.7893 74.955 80.06C75.1043 80.3307 75.179 80.6433 75.179 80.998C75.179 81.39 75.0623 81.7493 74.829 82.076C74.605 82.4027 74.269 82.664 73.821 82.86C73.3823 83.0467 72.8363 83.14 72.183 83.14Z",
    fill: "#013F60"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_378_2496",
    x: 0,
    y: 0,
    width: 109,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_378_2496"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.286275 0 0 0 0 0.427451 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_378_2496"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_378_2496",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_378_2496",
    x1: 152.5,
    y1: -33.3853,
    x2: -11.6863,
    y2: -10.2309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8AE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_378_2496",
    x1: 45.0609,
    y1: 29.4453,
    x2: 45.0609,
    y2: 50.7733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_378_2496",
    x1: 54.8046,
    y1: 31.0741,
    x2: 53.9582,
    y2: 31.0741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_378_2496",
    x1: 54.8046,
    y1: 33.9332,
    x2: 53.9582,
    y2: 33.9332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_378_2496",
    x1: 54.8046,
    y1: 36.7855,
    x2: 53.9582,
    y2: 36.7855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_378_2496",
    x1: 54.8046,
    y1: 39.6375,
    x2: 53.9582,
    y2: 39.6375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_378_2496",
    x1: 54.8046,
    y1: 42.4899,
    x2: 53.9582,
    y2: 42.4899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_378_2496",
    x1: 54.8046,
    y1: 45.3419,
    x2: 53.9582,
    y2: 45.3419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_378_2496",
    x1: 54.8046,
    y1: 48.2008,
    x2: 53.9582,
    y2: 48.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_378_2496",
    x1: 54.8046,
    y1: 51.0531,
    x2: 53.9582,
    y2: 51.0531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_378_2496",
    x1: 54.8046,
    y1: 53.9051,
    x2: 53.9582,
    y2: 53.9051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153D46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#397786"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_378_2496",
    x1: 63.94,
    y1: 29.4453,
    x2: 63.94,
    y2: 50.7733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#397786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#153D46"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthermaritalselected);
export default __webpack_public_path__ + "static/media/othermaritalselected.210a5e827ee59bca9b75cf39f8af8dfd.svg";
export { ForwardRef as ReactComponent };